import { createFileRoute } from '@tanstack/react-router';
import NoMember from '@my-pages/features/auth/views/NoMember.tsx';

export const Route = createFileRoute('/_static/ej-medlem')({
    component: NoMember,
});
